export const getCookie = (name: string) => {
  if (!document.cookie) {
    return null;
  }

  const cookies = document.cookie.split(";");

  for (const cookie of cookies) {
    const trimmedCookie = cookie.trim();
    if (trimmedCookie.substring(0, name.length + 1) !== `${name}=`) {
      continue;
    }

    return decodeURIComponent(trimmedCookie.substring(name.length + 1));
  }

  return null;
};
